import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LoadingStateComponent } from '../feedback';

@Component({
  standalone: true,
  selector: 'sb-upload',
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss',
  imports: [TranslateModule, LoadingStateComponent],
})
export class UploadComponent {
  public allowedTypes = input<string[]>();
  public multiple = input<boolean>();
  public _id = input<string>('input_file');
  public isUploading = input<boolean>(false);

  uploadedFiles = output<FileList>();

  public handleFileInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;

    if (!files || files.length === 0) return;

    this.uploadedFiles.emit(files);
  }
}
